export const stateSplicer = (arr, index) => {
  // if arr does not exist or is not of type array -> return empty arr
  if (!arr || !Array.isArray(arr)) return [];
  if (index > -1) return [...new Set([...arr.slice(0, index), ...arr.slice(index + 1, arr.length)])]
  return arr
};

export default {}
